import type { TicketAiAssistResponse } from '@gb-ticket/shared-types';

export type TicketCommentDraft = {
  body: string;
  isInternal: boolean;
};

export function commentBodyFromAssist(
  run: TicketAiAssistResponse,
  kind: 'public' | 'internal',
): string {
  if (kind === 'internal' && run.internalNote?.trim()) {
    return run.internalNote.trim();
  }
  if (kind === 'public' && run.publicReply?.trim()) {
    return run.publicReply.trim();
  }
  const parts: string[] = [];
  if (run.summary.trim()) {
    parts.push(run.summary.trim());
  }
  if (run.steps.length > 0) {
    parts.push(run.steps.map((step, index) => `${index + 1}. ${step}`).join('\n'));
  }
  if (kind === 'public' && run.followUpQuestions.length > 0) {
    parts.push(run.followUpQuestions.join('\n'));
  }
  return parts.join('\n\n').trim();
}
